import React from "react"
import styles from "./SearchResult.module.scss"

const SearchResult = ({ searchValue, points, onSelect }) => {
  if (searchValue.length < 3) {
    return null
  }

  const items = points.filter(it =>
    it.fullAddress.toLowerCase().includes(searchValue.toLowerCase())
  )

  return (
    <div className={styles.wrapper}>
      <div className={styles.list}>
        {items.length ? (
          items.map(item => (
            <div key={item.id} className={styles.item}>
              <div className={styles.services}>
                {item.services.map(({ title }) => title).join(", ")}
              </div>
              <button
                onClick={() => onSelect(item)}
                className={styles.title}
                type="button"
              >
                {item.fullAddress}
              </button>
            </div>
          ))
        ) : (
          <div className={styles.notFound}>Ничего не найдено</div>
        )}
      </div>
    </div>
  )
}

export default SearchResult
